/**
 * ChatInputEndedState — Ended/error state shown when the chat conversation has ended.
 *
 * Matches the new input box design (rounded-xl, border-gray-200).
 * Shows status message and "Start a new chat" link.
 */

import React from "react";
import { useTranslation } from "react-i18next";

const ChatInputEndedState = ({
  assistantColors,
  activeMatrix,
  endedStatus,
  realtimeError,
  customErrorMessage,
  getErrorMessage,
  onStartNewChat,
  plusMenu,
}) => {
  const { t } = useTranslation();

  return (
     <div className="border border-gray-200 rounded-xl bg-white shadow-sm">
      <div className="flex items-center gap-2 px-2.5 py-2">
        {plusMenu}
        <div className="flex items-center text-sm text-gray-500 min-w-0">
          {activeMatrix ? (
            <p className="mr-1">{t("selfImprovementFinished")}</p>
          ) : endedStatus > 300 || realtimeError ? (
            <p className="mr-1">{customErrorMessage || t("systemError")}</p>
          ) : (
            <p className="mr-1">{getErrorMessage()}</p>
          )}
          <button
            type="button"
            className="text-blue-600 hover:underline bg-transparent border-none cursor-pointer text-sm shrink-0"
            onClick={onStartNewChat}
          >
            {t("startNewChat")}
          </button>
        </div>
      </div>
    </div>
  );
};

export { ChatInputEndedState };
export default ChatInputEndedState;
